export default __webpack_public_path__ + "images/cb416fec78c86b275c772e9e8c34aa3a.webp";